import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ChevronRight, Home, TrendingUp, TrendingDown, ArrowUpRight, ArrowDownRight, Download, Globe } from 'lucide-react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
const exportData = [{
  commodity: 'Coffee',
  value: '$849M',
  volume: '6.2M bags (60kg)',
  share: '32.4%',
  change: '+12.3%',
  trend: 'up',
  destination: 'EU, USA, Japan'
}, {
  commodity: 'Fish & Fish Products',
  value: '$176M',
  volume: '28,400 MT',
  share: '6.7%',
  change: '+4.8%',
  trend: 'up',
  destination: 'EU, DRC, Kenya'
}, {
  commodity: 'Tea',
  value: '$89M',
  volume: '58,000 MT',
  share: '3.4%',
  change: '+6.2%',
  trend: 'up',
  destination: 'Kenya, Pakistan, UK'
}, {
  commodity: 'Tobacco',
  value: '$72M',
  volume: '32,000 MT',
  share: '2.7%',
  change: '-2.1%',
  trend: 'down',
  destination: 'Belgium, Netherlands, UK'
}, {
  commodity: 'Maize',
  value: '$68M',
  volume: '420,000 MT',
  share: '2.6%',
  change: '+15.4%',
  trend: 'up',
  destination: 'Kenya, South Sudan, DRC'
}, {
  commodity: 'Beans & Pulses',
  value: '$54M',
  volume: '180,000 MT',
  share: '2.1%',
  change: '+8.7%',
  trend: 'up',
  destination: 'Kenya, India, UAE'
}, {
  commodity: 'Flowers',
  value: '$48M',
  volume: '7,200 MT',
  share: '1.8%',
  change: '+3.5%',
  trend: 'up',
  destination: 'Netherlands, UK, Germany'
}, {
  commodity: 'Cocoa',
  value: '$42M',
  volume: '35,000 MT',
  share: '1.6%',
  change: '+22.1%',
  trend: 'up',
  destination: 'Netherlands, Belgium, Malaysia'
}];
const importData = [{
  commodity: 'Wheat & Wheat Flour',
  value: '$185M',
  change: '+9.2%',
  trend: 'up',
  source: 'Russia, Ukraine, Argentina'
}, {
  commodity: 'Palm Oil',
  value: '$142M',
  change: '+5.8%',
  trend: 'up',
  source: 'Malaysia, Indonesia'
}, {
  commodity: 'Sugar',
  value: '$78M',
  change: '-4.3%',
  trend: 'down',
  source: 'Brazil, India, Kenya'
}, {
  commodity: 'Rice',
  value: '$65M',
  change: '+11.2%',
  trend: 'up',
  source: 'Pakistan, India, Tanzania'
}, {
  commodity: 'Agricultural Machinery',
  value: '$58M',
  change: '+7.6%',
  trend: 'up',
  source: 'China, India, Japan'
}, {
  commodity: 'Fertilizers',
  value: '$52M',
  change: '+18.4%',
  trend: 'up',
  source: 'Kenya, China, Russia'
}];
const tradePartners = [{
  country: 'Kenya',
  exports: '$312M',
  imports: '$89M',
  balance: '+$223M'
}, {
  country: 'European Union',
  exports: '$485M',
  imports: '$42M',
  balance: '+$443M'
}, {
  country: 'DRC',
  exports: '$186M',
  imports: '$12M',
  balance: '+$174M'
}, {
  country: 'South Sudan',
  exports: '$145M',
  imports: '$8M',
  balance: '+$137M'
}, {
  country: 'India',
  exports: '$78M',
  imports: '$95M',
  balance: '-$17M'
}, {
  country: 'China',
  exports: '$24M',
  imports: '$68M',
  balance: '-$44M'
}];
export function TradeDataPage() {
  return <>
      <Header data-id="element-1545" />
      <main className="flex-grow pt-[160px] md:pt-[148px] bg-gray-50 pb-20" data-id="element-1546">
        <div className="relative text-white py-32 md:py-48 overflow-hidden" data-id="element-1547">
          <div className="absolute inset-0 bg-cover bg-center" style={{
          backgroundImage: 'url("https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=1600&h=600&fit=crop")'
        }} data-id="element-1548"></div>
          <div className="absolute inset-0 bg-uganda-green/80" data-id="element-1549"></div>
          <div className="relative max-w-7xl mx-auto px-4 md:px-8" data-id="element-1550">
            <div className="flex items-center text-sm text-green-100 mb-6" data-id="element-1551">
              <Link to="/" className="hover:text-white flex items-center" data-id="element-1552">
                <Home className="w-4 h-4 mr-1" data-id="element-1553" /> Home
              </Link>
              <ChevronRight className="w-4 h-4 mx-2" data-id="element-1554" />
              <span data-id="element-1555">Data & Statistics</span>
              <ChevronRight className="w-4 h-4 mx-2" data-id="element-1556" />
              <span className="text-white font-medium" data-id="element-1557">Trade Data</span>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-1558">
              Agricultural Trade Data
            </h1>
            <p className="text-lg text-green-50 max-w-3xl leading-relaxed" data-id="element-1559">
              Uganda's agricultural export and import statistics, trade
              balances, and key trading partners for the agricultural sector.
            </p>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 md:px-8 mt-12" data-id="element-1560">
          {/* Summary Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-1561">
            {[{
            label: 'Total Agric. Exports',
            value: '$2.62B',
            change: '+9.8%',
            trend: 'up'
          }, {
            label: 'Total Agric. Imports',
            value: '$680M',
            change: '+7.2%',
            trend: 'up'
          }, {
            label: 'Trade Balance',
            value: '+$1.94B',
            change: '+11.3%',
            trend: 'up'
          }].map((card, i) => <motion.div key={card.label} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="bg-white rounded-xl p-6 shadow-sm border border-gray-200" data-id="element-1562">
                <p className="text-sm text-gray-500 mb-2" data-id="element-1563">{card.label}</p>
                <div className="flex items-end justify-between" data-id="element-1564">
                  <p className="text-3xl font-bold text-uganda-black" data-id="element-1565">
                    {card.value}
                  </p>
                  <span className={`flex items-center gap-1 text-sm font-semibold ${card.trend === 'up' ? 'text-green-600' : 'text-red-500'}`} data-id="element-1566">
                    {card.trend === 'up' ? <ArrowUpRight className="w-4 h-4" data-id="element-1567" /> : <ArrowDownRight className="w-4 h-4" data-id="element-1568" />}
                    {card.change}
                  </span>
                </div>
                <p className="text-xs text-gray-400 mt-1" data-id="element-1569">FY 2022/23</p>
              </motion.div>)}
          </div>

          {/* Exports Table */}
          <div className="flex items-center justify-between mb-4" data-id="element-1570">
            <h2 className="text-2xl font-bold text-uganda-black" data-id="element-1571">
              Agricultural Exports
            </h2>
            <button className="flex items-center gap-2 text-sm font-semibold text-uganda-green hover:text-green-800 transition-colors" data-id="element-1572">
              <Download className="w-4 h-4" data-id="element-1573" /> Export Data
            </button>
          </div>
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden mb-12" data-id="element-1574">
            <div className="overflow-x-auto" data-id="element-1575">
              <table className="w-full" data-id="element-1576">
                <thead data-id="element-1577">
                  <tr className="bg-gray-50 border-b border-gray-200" data-id="element-1578">
                    <th className="text-left px-5 py-3 text-xs font-bold text-gray-600 uppercase tracking-wider" data-id="element-1579">
                      Commodity
                    </th>
                    <th className="text-right px-5 py-3 text-xs font-bold text-gray-600 uppercase tracking-wider" data-id="element-1580">
                      Value
                    </th>
                    <th className="text-right px-5 py-3 text-xs font-bold text-gray-600 uppercase tracking-wider hidden md:table-cell" data-id="element-1581">
                      Volume
                    </th>
                    <th className="text-right px-5 py-3 text-xs font-bold text-gray-600 uppercase tracking-wider hidden lg:table-cell" data-id="element-1582">
                      Export Share
                    </th>
                    <th className="text-left px-5 py-3 text-xs font-bold text-gray-600 uppercase tracking-wider hidden md:table-cell" data-id="element-1583">
                      Key Destinations
                    </th>
                    <th className="text-right px-5 py-3 text-xs font-bold text-gray-600 uppercase tracking-wider" data-id="element-1584">
                      YoY
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-1585">
                  {exportData.map((item, i) => <tr key={item.commodity} className={`border-b border-gray-100 ${i % 2 === 0 ? '' : 'bg-gray-50/50'}`} data-id="element-1586">
                      <td className="px-5 py-3 font-semibold text-uganda-black" data-id="element-1587">
                        {item.commodity}
                      </td>
                      <td className="px-5 py-3 text-right text-gray-700 font-medium" data-id="element-1588">
                        {item.value}
                      </td>
                      <td className="px-5 py-3 text-right text-gray-500 text-sm hidden md:table-cell" data-id="element-1589">
                        {item.volume}
                      </td>
                      <td className="px-5 py-3 text-right text-gray-500 text-sm hidden lg:table-cell" data-id="element-1590">
                        {item.share}
                      </td>
                      <td className="px-5 py-3 text-gray-500 text-sm hidden md:table-cell" data-id="element-1591">
                        {item.destination}
                      </td>
                      <td className="px-5 py-3 text-right" data-id="element-1592">
                        <span className={`inline-flex items-center gap-1 text-xs font-bold ${item.trend === 'up' ? 'text-green-600' : 'text-red-500'}`} data-id="element-1593">
                          {item.trend === 'up' ? <TrendingUp className="w-3 h-3" data-id="element-1594" /> : <TrendingDown className="w-3 h-3" data-id="element-1595" />}
                          {item.change}
                        </span>
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </div>

          {/* Imports Table */}
          <h2 className="text-2xl font-bold text-uganda-black mb-4" data-id="element-1596">
            Agricultural Imports
          </h2>
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden mb-12" data-id="element-1597">
            <div className="overflow-x-auto" data-id="element-1598">
              <table className="w-full" data-id="element-1599">
                <thead data-id="element-1600">
                  <tr className="bg-gray-50 border-b border-gray-200" data-id="element-1601">
                    <th className="text-left px-5 py-3 text-xs font-bold text-gray-600 uppercase tracking-wider" data-id="element-1602">
                      Commodity
                    </th>
                    <th className="text-right px-5 py-3 text-xs font-bold text-gray-600 uppercase tracking-wider" data-id="element-1603">
                      Value
                    </th>
                    <th className="text-left px-5 py-3 text-xs font-bold text-gray-600 uppercase tracking-wider hidden md:table-cell" data-id="element-1604">
                      Key Sources
                    </th>
                    <th className="text-right px-5 py-3 text-xs font-bold text-gray-600 uppercase tracking-wider" data-id="element-1605">
                      YoY
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-1606">
                  {importData.map((item, i) => <tr key={item.commodity} className={`border-b border-gray-100 ${i % 2 === 0 ? '' : 'bg-gray-50/50'}`} data-id="element-1607">
                      <td className="px-5 py-3 font-semibold text-uganda-black" data-id="element-1608">
                        {item.commodity}
                      </td>
                      <td className="px-5 py-3 text-right text-gray-700 font-medium" data-id="element-1609">
                        {item.value}
                      </td>
                      <td className="px-5 py-3 text-gray-500 text-sm hidden md:table-cell" data-id="element-1610">
                        {item.source}
                      </td>
                      <td className="px-5 py-3 text-right" data-id="element-1611">
                        <span className={`inline-flex items-center gap-1 text-xs font-bold ${item.trend === 'up' ? 'text-green-600' : 'text-red-500'}`} data-id="element-1612">
                          {item.trend === 'up' ? <TrendingUp className="w-3 h-3" data-id="element-1613" /> : <TrendingDown className="w-3 h-3" data-id="element-1614" />}
                          {item.change}
                        </span>
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </div>

          {/* Trade Partners */}
          <h2 className="text-2xl font-bold text-uganda-black mb-4" data-id="element-1615">
            Key Trading Partners
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-1616">
            {tradePartners.map((partner, index) => <motion.div key={partner.country} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.06
          }} className="bg-white rounded-xl p-5 shadow-sm border border-gray-200" data-id="element-1617">
                <div className="flex items-center gap-2 mb-3" data-id="element-1618">
                  <Globe className="w-5 h-5 text-uganda-green" data-id="element-1619" />
                  <h3 className="font-bold text-uganda-black" data-id="element-1620">
                    {partner.country}
                  </h3>
                </div>
                <div className="space-y-2 text-sm" data-id="element-1621">
                  <div className="flex justify-between" data-id="element-1622">
                    <span className="text-gray-500" data-id="element-1623">Exports</span>
                    <span className="font-semibold text-green-600" data-id="element-1624">
                      {partner.exports}
                    </span>
                  </div>
                  <div className="flex justify-between" data-id="element-1625">
                    <span className="text-gray-500" data-id="element-1626">Imports</span>
                    <span className="font-semibold text-red-500" data-id="element-1627">
                      {partner.imports}
                    </span>
                  </div>
                  <div className="flex justify-between border-t border-gray-100 pt-2" data-id="element-1628">
                    <span className="text-gray-500 font-medium" data-id="element-1629">Balance</span>
                    <span className={`font-bold ${partner.balance.startsWith('+') ? 'text-green-600' : 'text-red-500'}`} data-id="element-1630">
                      {partner.balance}
                    </span>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>
      </main>
      <Footer data-id="element-1631" />
    </>;
}